import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getProfessors, Professor } from "../backend/professors";
import Specialist from "../components/specialists/Specialist";
import SpecialistsGrid from "../components/specialists/SpecialistsGrid";
import Loading from "../components/_main/Loading";

function Docentes() {
    return (
        <div>
            <section className="specialistList">
                <div className="container">
                    <ul data-wow-delay="0.25s" className="specialistFilter wow fadeInUp">
                        <li data-filter="1"><span>Nacionales</span></li>
                        <li data-filter="2"><span>Internacionales</span></li>
                    </ul>
                    <div className="specialistListWrap">
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rogelio-cruz-martinez" className="specialistImgCircle">
                            <picture><img src="img/img-doctor-rogelio-martinez.png" width="600" height="600" alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Rogelio Cruz Martínez</h2>
                                <p>Medicina y Cirugia Fetal</p>
                                <p>Director General</p>
                            </div>
                            <ul className="specialistContact">
                                <li><a href="https://www.facebook.com/rogelio.cruz" target="_blnak"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="https://www.instagram.com/rogeliocruz/" target="_blnak"><i className="fa fa-instagram"></i></a></li>
                            </ul>
                        </div>
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-miguel-angel-martinez-rodriguez" className="specialistImgCircle">
                            <picture><img src="img/img-doctor-miguel-martinez.png" width="600" height="600" alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Miguel Martínez Rodríguez</h2>
                                <p>Director del Diplomado de Neurosonografía Fetal GDL</p>
                            </div>
                        </div>
                        
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a className="specialistImgCircle">
                            <picture><img src="img/img-doctor-hugo-lopez.png" width="600" height="600" alt="$name" style={{ "top": "0px" }} /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Hugo Pineda Alemán</h2>
                                <p>Director Medicina Fetal México Monterrey, San Luis Potosi, Veracruz</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>
                        
                        
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            className="specialistImgCircle">
                            <picture><img src="img/gaston.png" width="600" height="600" alt="$name"
                                style={{ "top": "0px" }} /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Gastón Estudillo Jiménez</h2>
                                <p>Director Medicina Fetal México Cuernavaca</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/img-doctor-rosa-villalobos.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dra. Rosa Villalobos Gómez</h2>
                                <p>Directora del Diplomado en Ecocardiografía Fetal CDMX</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>

                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/dr-andrea-pelaez.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dra. Andrea Peláez</h2>
                                <p>Directora del Diplomado en Ecocardiografía Fetal GDL</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>

                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/dr-leticia-lara.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dra. Leticia Lara</h2>
                                <p>Directora Medicina Fetal México Culiacán</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>

                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/antonio-helue-mena.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Antonio Helue Mena</h2>
                                <p>Director Medicina Fetal México CDMX</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/luz-bermudez.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dra. Ma. de la Luz Bermúdez</h2>
                                <p>Director Medicina Fetal México León Guanajuato</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>
                        <div data-type="$classification" data-wow-delay="0.25s" className="specialistBox wow fadeInUp"><a
                            href="https://medicinafetalmexico.com/especialista-rosa-helena-villalobos-gomez" className="specialistImgCircle">
                            <picture><img src="img/dr-edgar-flores.png" width="600" height="600"
                                alt="$name" /></picture>
                        </a>
                            <div className="specialistInfo">
                                <h2 className="h5">Dr. Edgar Flores</h2>
                                <p>Director Medicina Fetal México Chiapas</p>
                            </div>
                            <ul className="specialistContact">
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Docentes;